import styled from '@emotion/styled';
import { withConfig } from 'src/withConfig';

const PLAYER_MAX_HEIGHT_PX = 420;

export const GeniusLivePlayerWrapper = withConfig(theme => styled('div', { label: 'GeniusLivePlayerWrapper' })<{ maxSizePercentage: number; isVisible: boolean }>`
    background-color: ${theme.star.stream.bgColor};
    margin: 0 auto;
    max-width: min(${({ maxSizePercentage }): string => `${maxSizePercentage}%`}, calc(${PLAYER_MAX_HEIGHT_PX}px * 16 / 9));
    position: relative;
    width: 100%;

    ${({ isVisible }): string =>
        isVisible
            ? ''
            : `
        left: 0;
        opacity: 0;
        pointer-events: none;
        position: absolute;
        top: 0;
        visibility: hidden;
        z-index: -1;
    `}
`);

export const GeniusLivePlayerContainer = styled('div', { label: 'GeniusLivePlayerContainer' })`
    aspect-ratio: 16 / 9;
    max-height: ${PLAYER_MAX_HEIGHT_PX}px;
    position: relative;
    width: 100%;
`;
